export default {"src":"/_next/static/media/zoom-close-icon.91e663a4.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};